import { Component, HostBinding, Input } from '@angular/core';
import { mainMenu } from '../../../../../data/header-main-menu';
import { MainMenuLink } from '../../../../interfaces/main-menu-link';
import { HeaderService } from '../../../../services/header.service';
import { ApiService} from '../../../../service/api.service'
import { Router } from '@angular/router';
@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent {
    items: MainMenuLink[] = mainMenu;

    hoveredItem;
    @Input() show :boolean;

    @HostBinding('class.main-menu') classMainMenu = true;

    constructor(
        public header: HeaderService,
        public service : ApiService,
        public router : Router
    ) {

            this.items.push({'title': 'About Us', 'url': '/about-us'})
            this.items.push({'title': 'Contact Us', 'url': '/contact-us'})
            this.items.push({'title': 'Terms And Conditions', 'url': '/terms-and-conditions'})
            // this.items.push({'title': 'Privacy Policy', 'url': '/privacy-policy'})


    }

    onItemEnter(item: any): void {
        this.hoveredItem = item;
    }

    onItemLeave(item: any): void {
        if ( this.hoveredItem === item ) {
            this.hoveredItem = null;
        }
    }

    onItemClick(data?): void {
        this.hoveredItem = null;
        console.log(data)
        if(data){
            this.router.navigateByUrl(data)
        }
    }
    navigate(url){
        console.log(url)
    }
}
